import { render, staticRenderFns } from "./serviceProcess.vue?vue&type=template&id=8b5567f4&"
import script from "./serviceProcess.vue?vue&type=script&lang=js&"
export * from "./serviceProcess.vue?vue&type=script&lang=js&"
import style0 from "./serviceProcess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports